import { useState, useEffect, useMemo } from "react";
import { useCRMFunction } from "../../../customwidgets/sales-manager/hooks/useCRMFunction";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { IconButton, Tooltip, MenuItem, Select } from "@mui/material";
import { percentageCommission } from "../../../../util/DataObject";
import { Close } from "@mui/icons-material";

export const useManageCommission = ( changeLoader: ChangeLoaderCallbackType, changeAlert: ChangeAlertCallbackType, onConfirm, open: boolean) => {
    const { onHandleGetData, onHandleGetByUuid } = useCRMFunction(changeAlert);
    
    const [zPos, setZPos] = useState(45);
    const [form, setForm] = useState(null);
    const [lead, setLead] = useState(null);
    const [error, setError] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [sellers, setSellers] = useState([]);

    // REQ ------------------------------------------------
    const onHandleSave = (resp) => {
        let register = []
        resp?.sellers.map((i) => {
            return register.push({
                uuid: i.ref_uuid,
                commission: i.commission,
                status: i.status,
                seller: {
                    uuid: i["uuid"],
                    name: i["name"],
                    email: i["email"],
                    role: i["role"],
                }
            })
        })

        onSetLead(resp);
        setForm(JSON.parse(JSON.stringify(register)));
        return onHandleGet();
    };

    const onSetLead = (item) => {
        let l = {
            uuid: item["uuid"],
            company_name: item["company_name"] || item["general"]["company_name"],
            onboarding_email: item["onboarding_email"] || item["general"]["onboarding_email"],
            cdate: item["cdate"],
        }
        setLead(JSON.parse(JSON.stringify(l)));
    };


    const onHandleGetById = async (lead, tab) => {
        changeLoader(true);
        setZPos(-1);
        onSetLead(lead);

        let filter =  {
            uuid: lead["uuid"],
            type: tab,
            search_type: "uuid",
            status: "enabled"
        };

        let f = {
            filters: {
                status: "enabled"
            },
            pagination: {
                page_number: 1,
                results_per_page: 100
            }
        };

        Promise.all([
            onHandleGetByUuid(filter, tab),
            onHandleGetData(f, "sellerCrmList")
        ]).then(results => {
            let register = []
            results[0]?.sellers.map((i) => {
                return register.push({
                    uuid: i.ref_uuid,
                    commission: i.commission,
                    status: i.status,
                    seller: {
                        uuid: i["uuid"],
                        name: i["name"],
                        email: i["email"],
                        role: i["role"],
                    }
                })
            })
            setForm(JSON.parse(JSON.stringify(register)));
            setSellers(JSON.parse(JSON.stringify(results[1]["content"] || [])));
            setError("");
        }).catch((error) => {
            changeAlert(true, 'error', 'Error: ' + error);
        }).finally(() => {
            setZPos(45);
            changeLoader(false);
        })
    };

    const onHandleGet = async () => {
        changeLoader(true);
        setZPos(-1);

        let f = {
            filters: {
                status: "enabled"
            },
            pagination: {
                page_number: 1,
                results_per_page: 100
            }
        };

        Promise.all([
            onHandleGetData(f, "sellerCrmList")
        ]).then(results => {
            setSellers(JSON.parse(JSON.stringify(results[0]["content"] || [])));
            setError("");
        }).catch((error) => {
            changeAlert(true, 'error', 'Error: ' + error);
        }).finally(() => {
            setZPos(45);
            changeLoader(false);
        })
    };

    // FUNCT ------------------------------------------------

    const onHandleChange = (key, key2, e) => {
        let f = form;
        if (key2) {
            f.map((u) => {
                return u.seller.uuid === key2 ? (u[key] = e.target.value) : u;
            });
        } else {
            let d = e.target.value;
            let check = f ? f.filter((u) => u.seller.uuid === d.uuid) : [];
            if (check.length === 0) {
                let u = { seller: {
                    uuid: d.uuid,
                    name: d.name,
                    email: d.email || d["general"].email,
                    role: key
                }}

                f ? f.push(u) : (f = [u]);
            } else {
                return;
            }
        }

        setForm(JSON.parse(JSON.stringify(f)));
        validateForm(JSON.parse(JSON.stringify(f)));
    };

    const validateForm = (f) => {
        let checkPercentage = form.filter((u) => !u["commission"]);
        let enabledForm = form.filter((u) => u["status"] !== "disabled");
        
        function countEqualItems(arr, key, key2) {
            return arr.reduce((acc, obj) => {
                const value = obj[key][key2];
                acc[value] = (acc[value] || 0) + 1;
                return acc;
            }, {});
        }
        const checkTotal = countEqualItems(enabledForm, "seller", "role");
        const sumWithInitial = enabledForm.reduce(
            (accumulator, currentValue) => accumulator + currentValue.commission,
            0,
        );

        setForm(JSON.parse(JSON.stringify(f)));
        if (checkTotal["promoter"]) {
            sumWithInitial !== 12 && setError(JSON.parse(JSON.stringify("El porcentaje total deberá ser del 12%")));
        } else {
            sumWithInitial !== 10 && setError(JSON.parse(JSON.stringify("El porcentaje total deberá ser del 10%")));
        }

        if (f.length > 0 && checkPercentage.length === 0 && checkTotal["promoter"] ?  sumWithInitial === 12 :  sumWithInitial === 10) {
            setIsValid(false);
            setError("");
        } else {
            setIsValid(true);
        }
    };

    const onDeleteFromList = async (uuid, ref_uuid?, status?) => {
        let f = form;

        let cleanList = [];
        if(ref_uuid){
            cleanList = form.map((user) => {
                if(user.uuid === ref_uuid) {
                    user["status"] = status
                } 
                return user;
            }) 
        } else {
            cleanList = form.filter((user) =>  user.seller.uuid !== uuid);
        }
        f = cleanList;

        validateForm(JSON.parse(JSON.stringify(f)));
        setForm(JSON.parse(JSON.stringify(f)));
    };

    
    const onHandleConfirm = () => {
        let f = form;
        f.map((r) =>  !r["uuid"] ? r["lead"] = lead : r);

        setForm(JSON.parse(JSON.stringify(f)));
        return onConfirm(f);
    };

    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => row.seller.name, name: "Nombre", wrap: true, sortable: true, width: "40%" },
            { selector: (row) => row.seller.role === "agent" ? "Agente" : "Promotor", name: "Rol", wrap: true, sortable: true, width: "20%" },
            { cell: (row) => (
                    <Select label={"Porcentaje"} value={row["commission"] || -1} onChange={onHandleChange.bind(this, "commission", row.seller.uuid)} color="secondary" MenuProps={{ style: { zIndex: 35001 } }} variant="standard" fullWidth>
                        <MenuItem value={-1} disabled>Seleccione</MenuItem>
                        {percentageCommission.map((i) => (
                            <MenuItem key={`commission-${i.key}`} value={i.key}>
                                {i.label}
                            </MenuItem>
                        ))}
                    </Select>
                ), name: "Porcentaje", wrap: true, sortable: true,
            },
            { cell: (row) => {
                    return (
                        <Tooltip title={"Eliminar"}>
                            <IconButton sx={{ px: "0 !important", mr: 1 }} onClick={() => onDeleteFromList(row.seller.uuid, row['uuid'] || null, "disabled")}>
                                <Close titleAccess={`Eliminar de \nla lista`} cursor={"pointer"}/>
                            </IconButton>
                        </Tooltip>
                    );
                }, wrap: true, sortable: true, width: "10%",
            }
        ];
        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form]);

    useEffect(() => {
        if (!open) {
            setForm(null);
            setError("");
            setIsValid(true);
            setLead(null);
            setSellers([]);
        }
    }, [open]);

    return {
        zPos,
        form,
        error,
        isValid,
        sellers,
        columns: calculateColumns,
        onHandleSave,
        onHandleGet,
        onHandleGetById,
        onHandleChange,
        onHandleConfirm,
        onDeleteFromList,
    };
};
